import { Routes } from '@angular/router';
import { monitoringMobilePage } from '../monitoring/monitoring.mobile.component';
import { settingsMobilePage } from '../settings/settings.mobile.component';
import { AnalyticsMobilePage } from '../analytics/analytics.mobile.component';
import { AlertsHistoryMobilePage } from '../alertsHistory/alertsHistory.mobile.component';

export const MobileRootRoutes: Routes = [
  {
    path: 'guide',
    loadComponent: () => import('../../guide/guide.page').then(module => module.GuidePage)
  },

  {
    path: "monitoring",
    component: monitoringMobilePage,
  },
  {
    path: "settings",
    component: settingsMobilePage
  },
  /* Statistiche */
  {
    path: 'analytics',
    component: AnalyticsMobilePage,
  },
  /* Statistiche */
  {
    path: 'alertsHistory',
    component: AlertsHistoryMobilePage,
  },
  {
    path: '',
    redirectTo: 'monitoring',
    pathMatch: 'full',
  }
];
